import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITreeViewsService = ( createDecorator('treeViewsService'));
export { ITreeViewsService };
